var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('div',[_c('GroupingFilter',{key:_vm.groupingRefreshKey,attrs:{"nonGroupMembers":_vm.selectActiveLocations,"disabledNonGroupMembers":_vm.forCampaign ? null : _vm.selectDisabledLocations,"nonGroupMemberLabel":"Locations","memberType":"location","init":{
      nonGroupMemberIds: this.filteredLocations,
      groupIds: null,
      disabledNonGroupMemberIds: null
    }},on:{"update":_vm.groupingUpdate}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }